"use client";

import { c as _c } from "react/compiler-runtime";
import { SidebarTrigger } from "@/components/ui/sidebar";
interface OrgHeaderProps {
  organizationName?: string;
}
export const OrgHeader = t0 => {
  const $ = _c(5);
  const {
    organizationName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SidebarTrigger />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== organizationName) {
    t2 = organizationName ? <span className="text-sm font-medium text-muted-foreground truncate">{organizationName}</span> : null;
    $[1] = organizationName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <header className="bg-background flex items-center border-b p-4"><div className="flex min-w-0 flex-1 items-center gap-3">{t1}{t2}</div></header>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};